/** Typing pause after which the next keystroke starts a new undo step. */
export const TEXT_UNDO_PAUSE_MS = 1000;

export type TextUndoStep = { segmentId: number; at: number } | null;

/**
 * Whether a caption text edit starts a new document undo step (#4029).
 *
 * Text edits share one linear history with insert/split/delete/timing so
 * Ctrl+Z always undoes the latest change. Typing is grouped into one step
 * until the user moves to another segment or pauses for a second, so undo
 * works per phrase instead of per keystroke.
 */
export const startsTextUndoStep = (
  current: TextUndoStep,
  segmentId: number,
  now: number
): boolean =>
  !current ||
  current.segmentId !== segmentId ||
  now - current.at > TEXT_UNDO_PAUSE_MS;
